/** Display text for corresponding values for snap personas. */
export const snapPersonasDisplayTextMap: Record<string, string> = {
  // This value is set whenever a user signs in to ads manager/business manager/profile manager.
  s1: 'Signed Up User',
} as const;
